import { render } from "./ReplicaEditor.vue?vue&type=template&id=2dfb25e0&scoped=true&ts=true"
import script from "./ReplicaEditor.vue?vue&type=script&lang=ts"
export * from "./ReplicaEditor.vue?vue&type=script&lang=ts"

import "./ReplicaEditor.vue?vue&type=style&index=0&id=2dfb25e0&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dfb25e0"]])

export default __exports__